import {
  Bin,
  Prompt,
  SnackbarStatus,
  useSnackbar,
  VenueIcon,
  ViewIcon,
  Card as VenueCard,
  IOption,
} from '@weareopenr/component-library';
import { useState } from 'react';
import { deleteVenue } from 'src/api/deleteVenue/deleteVenue';
import { useVenues } from 'src/hooks/useVenues/useVenues';

interface IVenueSummaryProps {
  title: string;
  subtitle: string;
  venueId?: string;
  onViewClick?: () => void;
  image?: string;
}

export const VenueSummary = ({ title, venueId, subtitle, onViewClick, image }: IVenueSummaryProps): JSX.Element => {
  const [isRemovePromptVisible, setIsRemovePromptVisible] = useState<boolean>(false);
  const { showSnackbar } = useSnackbar();
  const { refetch } = useVenues();
  const handleClick = (): void => setIsRemovePromptVisible((prev) => !prev);

  const removePromptTitle = `Are you sure you want to delete "${title}" venue?`;
  const removeVenuePromptSubTitle = 'You will remove this product from the current menu.';

  const handleDelete = async () => {
    try {
      await deleteVenue(venueId);
      await refetch();
      showSnackbar({
        status: SnackbarStatus.SUCCESS,
        message: `You have successfully deleted ${title} venue!`,
      });
    } catch (e) {
      showSnackbar({
        status: SnackbarStatus.ERROR,
        message: 'We were unable to delete, please try again!',
      });
    } finally {
      handleClick();
    }
  };

  const ellipsisOptions: IOption[] = [
    {
      id: 'view',
      name: 'View',
      icon: ViewIcon,
      onOptionClick: onViewClick,
    },
    {
      id: 'delete',
      name: 'Delete',
      icon: Bin,
      hoverColour: 'tomato',
      onOptionClick: handleClick,
    },
  ];

  return (
    <>
      <Prompt
        promptHeading={removePromptTitle}
        closePrompt={handleClick}
        open={isRemovePromptVisible}
        buttonHandler={handleDelete}
        buttonText="Delete"
        buttonColour="tomato"
        backButton={true}
        size="small"
      >
        {removeVenuePromptSubTitle}
      </Prompt>
      <VenueCard
        text={title}
        subtext={subtitle}
        imageSrc={image}
        icon={VenueIcon}
        to={`/venues/${venueId}`}
        ellipsisOptions={ellipsisOptions}
      />
    </>
  );
};
